export default (): object => {
  return {
    input: {
      color: '#222324',
      fontSize: '14px',
      height: '52px',
      borderRadius: '2px'
    },
    inputbackground: {
      color: '#ffffff'
    },
    labels: {
      color: '#424242',
      fontSize: '12px'
    },
    headings: {
      color: '#333',
      fontSize: '14px'
    },
    loader: {
      color: '#9c72b6'
    },
    error: {
      color: '#ff2e56'
    },
    buttons: {
      color: '#9c72b6'
    },
    headerbackground: {
      color: '#ffffff'
    },
    background: {
      color: '#ffffff'
    },
    cashierbackground: {
      color: '#ffffff'
    },
    cardbackground: {
      color: 'transparent'
    },
    border: {
      radius: '4px'
    },
    margin: {
      size: '14px'
    },
    creditcardicons: {
      creditcardUrl: 'default',
      cvvUrl: 'default',
      expirydateUrl: 'default'
    }
  }
}
